import {t} from '@github-ui/swp-core/lib/utils/localization'
import type {SupportedLocale} from '@github-ui/swp-core/lib/utils/localization'
import type {BannerDescriptor} from './marketing-global-banner.types'

/**
 * To add a banner, append a descriptor here and register its `feature_flag` in the `jsFeatureFlags`
 * allowlist in `@github-ui/feature-flags`, or it will never be enabled client-side.
 */
export function getBannerRegistry(locale?: SupportedLocale): BannerDescriptor[] {
  return [
    {
      uid: 'universe26_seblaunch',
      title: '120+ talks, demos, and workshops await at Universe 2026, but IRL passes are going fast.',
      link: 'https://githubuniverse.com/?utm_source=github&utm_medium=banner&utm_campaign=db_ebsession_uni26',
      link_label: 'Register now',
      mode: 'light',
      custom_design: 'universe_26',
      allowed_paths: [
        '/open-source/sponsors',
        '/open-source/accelerator',
        '/enterprise',
        '/enterprise/startups',
        '/features/copilot/copilot-business',
        '/team',
        '/security/advanced-security',
      ],
      feature_flag: 'universe26_ebsessionlaunch',
    },
    {
      uid: 'desktop_copilot_app',
      title: 'Looking for an agent-driven desktop experience?',
      link: 'https://github.com/features/ai/github-app?utm_source=github&utm_medium=banner&utm_campaign=desktop_copilot_app',
      link_label: 'Download the GitHub Copilot app',
      mode: 'dark',
      allowed_paths: ['/apps/desktop'],
      feature_flag: 'site_banner_desktop_copilot_app',
    },
    {
      uid: 'security_webinar',
      title: 'Secret Leaks: Trends, Risks, and How to Respond',
      link: 'https://github.registration.goldcast.io/webinar/77c2c07e-1cd1-4f17-9f4c-7d1500a658e9?utm_source=gh_web_banner&utm_medium=web&utm_campaign=SecurityPodJuly28',
      link_label: 'Register now',
      mode: 'dark',
      allowed_paths: [
        '/security',
        '/security/advanced-security/secret-protection',
        '/security/advanced-security/code-security',
      ],
      feature_flag: 'site_global_banner_security_webinar',
    },
    {
      uid: 'copilot_day',
      title:
        'Join GitHub Copilot Day, live on Sept 10. Come for the product news, stay for the demos, live coding, and surprises.',
      link: 'https://gh.io/GitHubCopilotDay?utm_source=github&utm_medium=banner&utm_campaign=github_copilot_day',
      link_label: 'Set your reminder',
      mode: 'dark',
      allowed_paths: ['/', '/home'],
      feature_flag: 'site_global_banner_copilot_day',
    },
    {
      uid: 'learn_copilot_sdk',
      title: 'New to the GitHub Copilot SDK? Join us live and learn how to build agentic apps from the ground up.',
      link: 'https://gh.io/letslearn?utm_source=github&utm_medium=banner&utm_campaign=learn_copilot_sdk',
      link_label: 'Register now',
      mode: 'dark',
      allowed_paths: ['/features/copilot/tutorials', '/features/copilot/ai-code-editor'],
      feature_flag: 'site_global_banner_learn_copilot_sdk',
    },
    {
      uid: 'dev_days_attendee',
      title: t(
        'Dev Days are here! Join an in-person event near you to learn more about the GitHub Copilot app and Copilot CLI with your community.',
        locale,
      ),
      link: 'https://gh.io/join-dev-days?utm_source=github&utm_medium=banner&utm_campaign=dev_days_attendee',
      link_label: 'Find an event',
      mode: 'dark',
      allowed_paths: [
        '/features/copilot',
        '/features/copilot/cli',
        '/features/copilot/plans',
        '/features/ai/github-app',
        '/features',
        '/resources',
      ],
      feature_flag: 'site_global_banner_dev_days_attendee',
    },
  ]
}
